import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
}), 'VerticalAlignBottom');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalAlignBottom.js
// module id = 7010
// module chunks = 2